// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2x6iJ","buttons":"PendingPaymentAlert_buttons__13Exi"};